var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGuideAccaGreen = function SvgIconGuideAccaGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7h30.333a2.333 2.333 0 0 1 2.334 2.333v37.334A2.333 2.333 0 0 1 44.333 49H14a4.67 4.67 0 0 1-4.667-4.667V11.667A4.67 4.67 0 0 1 14 7Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7h2.333v42H14a4.67 4.67 0 0 1-4.667-4.667V11.667A4.67 4.67 0 0 1 14 7Z",
    fill: "#239A6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.148 31.658a4.398 4.398 0 1 0 0-8.797 4.398 4.398 0 0 0 0 8.797Z",
    fill: "#CFFCEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.464 27.953H29c-.644 0-1.166.523-1.166 1.167v6.463c0 .645.522 1.167 1.166 1.167h6.464c.644 0 1.166-.523 1.166-1.167V29.12c0-.645-.522-1.167-1.166-1.167Z",
    fill: "#9EEED3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.993 23.783 33.4 19.35a.585.585 0 0 0-.91.484V28.7c0 .466.522.743.91.484l6.594-4.434a.583.583 0 0 0 0-.968Z",
    fill: "#fff"
  })));
};
export default SvgIconGuideAccaGreen;